import BaseModel from "./BaseModel";
import SessionModel from "./SessionModel";

export default class NoteModel extends BaseModel {
  status?: "passed" | "unpassed";
  note?: string;
  session?: SessionModel;
  constructor(arg: any) {
    super(arg);
    this.status = arg?.state ? arg?.state : arg?.status;
    this.note = arg?.title;
    this.session = SessionModel.fromApiResponse(arg?.session);
  }
}
